<ion-header class="ion-no-border shadow-b-footer" mode="ios">
  <ion-toolbar>
    <ion-title>{{ 'LANGUAGE.TITLE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <background-content [classSubDiv]="'h-100'">
    <ion-list class="m-0 p-0 h-100 bg-transparent">
      <app-box-white [classDiv]="'mt-16 p-8 br-8'">
        <ion-radio-group [(ngModel)]="currentLang">
          <ion-item
            *ngFor="let item of listOfLanguages; let i = index"
            class="item-no-border p-relative f_normal h-45 transform-none psr-bg-box radius-4 p-start-0 item-n-border"
            [ngClass]="{ 'mt-8': i > 0 }">
            <ion-label class="my-10 mx-0">{{item.name}}</ion-label>
            <ion-radio
              mode="md"
              class="radio-passer-white radio-16"
              [value]="item.code"></ion-radio>
          </ion-item>
        </ion-radio-group>
      </app-box-white>
    </ion-list>
  </background-content>
</ion-content>

<ion-footer class="ion-no-border flex">
  <ps-button
    buttonClass="mr-8 mt-16"
    class="w-100"
    color="secondary"
    data-testid="button-close-modal"
    height="tall"
    width="100%"
    [text]="'actions.cancel' | translate"
    (onClick)="closeModal()">
  </ps-button>
  <ps-button
    buttonClass="mt-16 ml-8"
    class="w-100"
    data-testid="button-save-lang"
    height="tall"
    width="100%"
    [disabled]="currentLang === langFromStore"
    [text]="'actions.save' | translate"
    (onClick)="saveLang()">
  </ps-button>
</ion-footer>
